import { LoanConditionalOptions } from 'pages/Dashboard/steps/AcceptOffer/acceptOffer.enums';

export const LOAN_OPTIONS_NAMES = [
  LoanConditionalOptions.FixedRates,
  LoanConditionalOptions.NoPrepaymentPenalty,
  LoanConditionalOptions.NoEquityAndNoAppraisal,
  LoanConditionalOptions.QuickFunding,
  LoanConditionalOptions.DirectToConsumerFunded,
  LoanConditionalOptions.AutopayMayImpact,
];
